import { DefaultTheme } from 'styled-components';
import { palette } from 'styles/color';

const theme: DefaultTheme = {
  colors: {
    primary: palette.blue[500],
    secondary: palette.blue[500],
    error: palette.red,
    // warning: palette.yellow,
    // success: palette.green,
    default: palette.black
  }
};

export default theme;
